import { CALL_API } from '../../middleware/api'

export const FETCH_GAMBLER_INFO = 'FETCH_GAMBLER_INFO';
export const SUCCESS_FETCH_GAMBLER_INFO = 'SUCCESS_FETCH_GAMBLER_INFO';
export const FAILURE_FETCH_GAMBLER_INFO = 'FAILURE_FETCH_GAMBLER_INFO';

export function getGamblerInfo() {
  return (dispatch) => {
    dispatch({
      type: FETCH_GAMBLER_INFO,
      [CALL_API]: {
        endpoint: '/api/gambler',
        method: 'GET',
        types: [SUCCESS_FETCH_GAMBLER_INFO, FAILURE_FETCH_GAMBLER_INFO],
        credentials: true,
      }
    });
  };
}


// WEBPACK FOOTER //
// ./js/actions/creators/GamblerInfo.js